import workspaceQuery from 'graphql/queries/salesLedger/SalesCreditReasonWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/salesLedger/SalesCreditReasonListQuery.graphql';
import instanceQuery from 'graphql/queries/salesLedger/SalesCreditReasonQuery.graphql';
import defaultQuery from 'graphql/queries/salesLedger/SalesCreditReasonDefault.graphql';
import mutationQuery from 'graphql/mutations/salesLedger/SalesCreditReasonMutation.graphql';
import fragment from 'graphql/fragments/salesLedger/SalesCreditReasonFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const SalesCreditReason: EntityType = {
  type: 'SalesCreditReason',
  title: 'Credit Reason',
  formTitle: 'Credit Reason',
  formUrl: '/Customers/CreditReason/Details/',
  workspaceUrl: '/Customers/CreditReason/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
    remoteFilter: true,
    preLoad: true,
  },
  fragment,
  screenReference: 'SALES_LEDGER_CREDIT_REASON',
};

export default SalesCreditReason;
